import { i18n } from "@lib/i18n";
import { globalLayoutRoute } from "@routes";
import { allowAdminAndUser, redirectToAccessFallback, requireScope } from "@routes/authorization";
import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

export const invoicesRoute = createRoute({
    getParentRoute: () => globalLayoutRoute,
    path: `invoices`,
    component: lazyRouteComponent(() => import("./Invoices"), "Invoices"),
    beforeLoad: async () => {
        const allowedAdminAndUser = await allowAdminAndUser();
        if (!allowedAdminAndUser) {
            redirectToAccessFallback();
        }
        requireScope("account");

        return { getTitle: () => i18n.doc_title_invoices() };
    },
});
